import { FC, useCallback } from 'react';
import { Box, Drawer } from '@mui/material';
import { useAppContext } from '@/context/App.context';
import { useTranslation } from 'react-i18next';

import { MobileList, MobileListItemInterface } from '../MobileList/MobileList';
import { drawerContent, SideBarNavigationMobile } from './SideBarNavigation.styles';
import { useSelectIsMenuOpen, useSetIsMenuOpen } from '@/store/useAppStore';

export const SideBarNavigation: FC = () => {
  const { isLoggedIn } = useAppContext();
  const { t } = useTranslation();
  const isMenuOpen = useSelectIsMenuOpen();
  const setIsMenuOpen = useSetIsMenuOpen();

  const handleClose = useCallback(() => {
    setIsMenuOpen(false);
  }, [setIsMenuOpen]);

  const dashboardMobileItems: MobileListItemInterface[] = [
    ...(isLoggedIn
      ? [
          { link: '/dashboard/tests', label: t('menuLabels.myTests') },
          { link: `/dashboard/practice`, label: t('menuLabels.practice') }
        ]
      : []),
    {
      link: `/${isLoggedIn ? 'dashboard/' : ''}test-format`,
      label: t('menuLabels.testFormats')
    },
    {
      link: `/${isLoggedIn ? 'dashboard/' : ''}for-institutions`,
      label: t('menuLabels.forInstitutions')
    }
  ];

  return (
    <Drawer
      sx={SideBarNavigationMobile(!!isLoggedIn)}
      open={isMenuOpen}
      onClose={handleClose}
      variant='temporary'
      anchor='right'
    >
      <Box sx={drawerContent}>
        <MobileList items={dashboardMobileItems} setIsMenuOpen={setIsMenuOpen} />
      </Box>
    </Drawer>
  );
};
